class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.CartDrawer = document.querySelector('.drawer__inner')
    this.cartLinks = document.querySelectorAll('#cart-link');
    this.overlay = document.querySelector('body > .overlay')
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.overlay.addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    document.addEventListener('shopify:section:load', this.setHeaderCartIconAccessibility.bind(this));
    document.querySelector('#shopify-section-cart-drawer').addEventListener('shopify:section:select', this.sectionSelect.bind(this));
    document.querySelector('#shopify-section-cart-drawer').addEventListener('shopify:section:deselect', this.close.bind(this));
    
    // Initialize bubble visibility on page load
    this.updateBubbleVisibility();
  }

  setHeaderCartIconAccessibility() {
    this.cartLinks = document.querySelectorAll('#cart-link');
    Array.from(this.cartLinks).forEach(cartLink => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'ENTER') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    })
  }

  sectionSelect() {
    this.cartLink = document.querySelector('#cart-link')
    this.open(this.cartLink)
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    if(document.body.classList.contains('quick-view-open')) {
      document.body.classList.remove('hidden', 'quick-view-open', 'quick-view-load')
      let openedQuickView = document.querySelector('.popup-wrapper__quick-view.open')
      if(openedQuickView) {
        openedQuickView.closest('details').removeAttribute('open')
        openedQuickView.closest('.quick-view__content').classList.remove('hide-cover');
        openedQuickView.classList.remove('open')
        openedQuickView.closest('.quick-view__content').innerHTML = '';
      }
    }
    setTimeout(() => {this.classList.add('animate', 'active')});
    this.overlay.classList.add('open')
    document.body.classList.add('hidden');
    this.CartDrawer.setAttribute('tabindex', '0')
    setTimeout(() => trapFocus(triggeredBy, this.CartDrawer.querySelector('a')), 10)
    if (document.querySelector('#shopify-section-menu-drawer .menu-drawer.open') || document.querySelector('#shopify-section-mega-menu-drawer .menu-drawer.open')) {
      document.querySelector('.menu-drawer').setAttribute('hidden', 'true')
      document.querySelector('.menu-drawer').classList.remove('open')
    }
    document.dispatchEvent(new CustomEvent('cart-drawer:open'));
  }

  close() {
    this.classList.remove('active');
    this.overlay.classList.remove('open')
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('hidden')
    document.dispatchEvent(new CustomEvent('body:visible'));
    this.CartDrawer.setAttribute('tabindex', '-1')
  }

  // New method to update bubble visibility based on cart count
  updateBubbleVisibility() {
    // Get the cart count bubble using your specific selector
    const cartBubbles = document.querySelectorAll('#cg-cart-count');
    
    cartBubbles.forEach(bubble => {
      const countText = bubble.textContent.trim();
      const count = parseInt(countText) || 0;
      
      if (count === 0) {
        bubble.style.display = 'none';
      } else {
        bubble.style.display = '';
      }
    });
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElements = document.querySelectorAll(section.selector);
      if(sectionElements) {
        Array.from(sectionElements).forEach(sectionElement => {
          const newHtml = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          if (newHtml !== null) sectionElement.innerHTML = newHtml;
        })
      } 
    }));

    // Update bubble visibility after rendering new content
    this.updateBubbleVisibility();

    if(this.className.includes('open-after-adding')) {
      setTimeout(() => {
        document.querySelector('body > .overlay').addEventListener('click', this.close.bind(this));
        this.open();
      });
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return null;
    const dom = new DOMParser().parseFromString(html, 'text/html');
    const el = dom.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  getSectionsToRender() {
    let arraySections = []
    if (window.innerWidth > 920 && document.querySelector('.header-without-sidebars')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'custom-header',
          selector: '#cg-cart-count'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'header',
          selector: '#cart-icon-bubble-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else if (window.innerWidth > 920 && document.querySelector('.secondary-header-section')) {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'custom-header',
          selector: '#cg-cart-count'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'secondary-header',
          selector: '#cart-icon-bubble-secondary-header'
        },
        {
          id: 'secondary-sidebar',
          selector: '#cart-icon-bubble-secondary-sidebar'
        },
        {
          id: 'main-sidebar',
          selector: '#cart-icon-bubble-main-sidebar'
        }
      ];
    } else {
      arraySections = [
        {
          id: 'cart-drawer',
          selector: '#CartDrawer'
        },
        {
          id: 'custom-header',
          selector: '#cg-cart-count'
        },
        {
          id: 'menu-drawer',
          selector: '#cart-icon-bubble-menu-drawer'
        },
        {
          id: 'mobile-header',
          selector: '#cart-icon-bubble-mobile-header'
        }
      ];
    }
    return arraySections
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);